import { render } from "./SectionMatches.vue?vue&type=template&id=58114017&scoped=true"
import script from "./SectionMatches.vue?vue&type=script&lang=js"
export * from "./SectionMatches.vue?vue&type=script&lang=js"

import "./SectionMatches.vue?vue&type=style&index=0&id=58114017&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58114017"]])

export default __exports__